export default __webpack_public_path__ + "static/media/raspberry_pi_icon.e9919384.svg";